import http from "@/utils/request";
// 查询
export const getTutorialList = (params) => {
  return http.get("/JobTutorial/GetList", params);
};
// 删除
export const deleteTutorial = (params) => {
  return http.get("/JobTutorial/Remove", params);
};
// 获取修改信息
export const getTutorialItem = (params) => {
  return http.get("/JobTutorial/GetEntity", params);
};
// 保存
export const SaveTutorial = (data) => {
  return http.post("/JobTutorial/Save", data);
};
//Template Type
export const getType = (data) => {
    return http.get("/Lookup/GetListByType", data);
};
//直接打開
export const directOpenItem = (params) => {
  return http.get("/JobTutorial/GetEntityByEncrypt", params);
};
//返回限時訪問Url
export const generate_Url = (params) => {
  return http.get("/JobTutorial/GenerateUrl", params);
};